function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import { SearchBar, useWindowDimensions } from '../SearchBar';
import { DesktopMenu } from '../DesktopMenu';
import { MobileMenu } from '../MobileMenu';
import { AgroHeaderContext } from '../../contexts/AgroHeaderContext';
import { AgroHamburgerButton } from '../../atoms/AgroHamburgerButton';
import { UserWrapper } from '../UserWrapper';
import { IhamburgerMenu } from '../../atoms/AgroIcon/icons';
import { AgroSpinner } from '../../atoms/AgroSpinner';
import { getMenu } from '../Header/getMenu';
import { getHeaderButtons } from '../Header/getHeaderButtons';
import { buildNotifications } from '../Header/buildNotifications';
// import logger from '../../utils/logger';

import { LogoContainer, HamburgerButtonContainer, HeaderTagStyled, HeaderContainer, MainHeader, MenuContainer, AgrofyLogo, AgrofyLogoFull, LeftContent, MobileSpinnerContainer, CategoriesContainer, CategoriesButton, CategoriesItem, Loading } from './StyledHeader';
var Header = withCssProps(function () {
  var _useContext = useContext(AgroHeaderContext),
    baseUrl = _useContext.baseUrl,
    loginUrlRedirect = _useContext.loginUrlRedirect,
    translations = _useContext.translations,
    tagManager = _useContext.tagManager,
    apiGateway = _useContext.apiGateway,
    notifications = _useContext.notifications,
    loadingUser = _useContext.loadingUser,
    loadingNotifications = _useContext.loadingNotifications,
    _onClick = _useContext.onClick,
    urlServices = _useContext.urlServices,
    language = _useContext.language;
  var isMobile = useWindowDimensions();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenMenu = _useState2[0],
    setIsOpenMenu = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocus = _useState4[0],
    setIsFocus = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoadingMenu = _useState6[0],
    setIsLoadingMenu = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    firstOpenMenu = _useState8[0],
    setFirstOpenMenu = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    onlineStore = _useState10[0],
    setOnlineStore = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    itemsMenuDesktop = _useState12[0],
    setItemsMenuDesktop = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    itemsMenuMobile = _useState14[0],
    setItemsMenuMobile = _useState14[1];
  var _useState15 = useState({}),
    _useState16 = _slicedToArray(_useState15, 2),
    notificationsBuilt = _useState16[0],
    setNotificationsBuilt = _useState16[1];
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    headerButtons = _useState18[0],
    setHeaderButtons = _useState18[1];
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    resultsOther = _useState20[0],
    setResultsOther = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    loading = _useState22[0],
    setLoading = _useState22[1];
  var country = {
    'es-AR': 'argentina',
    'es-BO': 'bolivia',
    'es-CL': 'chile',
    'es-CO': 'colombia',
    'es-PE': 'peru',
    'es-PY': 'paraguay',
    'es-UY': 'uruguay',
    'pt-BR': 'brasil'
  };
  var functionSort = function functionSort(s) {
    s.sort(function (a, b) {
      if (a.Score < b.Score) {
        return 1;
      }
      if (a.Score > b.Score) {
        return -1;
      }
      if (a.Suggestion < b.Suggestion) {
        return 1;
      }
      if (a.Suggestion > b.Suggestion) {
        return -1;
      }
      return 0;
    });
    return s;
  };
  useEffect(function () {
    setLoading(true);
    fetch("https://apigateway-".concat(country[language], ".agrofy.com/api/suggestions/oneclick")).then(function (response) {
      return response.json();
    }).then(function (data) {
      var _data$Content$others_;
      var otherSuggest = ((_data$Content$others_ = data.Content.others_suggest) === null || _data$Content$others_ === void 0 ? void 0 : _data$Content$others_.Suggestions) || [];
      var othersSuggest = functionSort(otherSuggest);
      var filterOthers = othersSuggest.slice(0, 6);
      filterOthers && filterOthers.length && setResultsOther(filterOthers.map(function (item, idx) {
        return {
          item: item,
          id: idx + filterOthers.length
        };
      }));
      setLoading(false);
    });
  }, []);
  useEffect(function () {
    notifications && Object.keys(notifications).length && setNotificationsBuilt(buildNotifications(notifications, translations));
    if (firstOpenMenu) {
      setIsLoadingMenu(true);
      getMenu(apiGateway).then(function (data) {
        setOnlineStore(data.desktop.pop());
        setItemsMenuDesktop(data.desktop);
        setItemsMenuMobile(data.mobile.map(function (item) {
          if (item.URL === '/login') {
            item.URL = "/auth?urlRedirect=".concat(loginUrlRedirect || baseUrl);
          }
          return item;
        }));
        setIsLoadingMenu(false);
      })["catch"](function (error) {
        console.error(error);
      });
    }
    getHeaderButtons(urlServices).then(function (data) {
      setHeaderButtons(data);
    })["catch"](function (error) {
      console.error(error);
    });
  }, [apiGateway, firstOpenMenu, notifications]);
  var openMenu = function openMenu() {
    !firstOpenMenu && setFirstOpenMenu(true);
    setIsOpenMenu(true);
    document.addEventListener('click', handleClickOutside, true);
    document.body.style.top = "-".concat(window.scrollY, "px");
    document.body.style.paddingRight = '15px';
    document.body.style.width = '100%';
    document.body.style.position = 'fixed';
  };
  var closeMenu = function closeMenu() {
    var scrollY = document.body.style.top;
    setIsOpenMenu(false);
    document.body.style.position = '';
    document.body.style.paddingRight = '';
    document.body.style.top = '';
    document.body.style.width = '';
    // eslint-disable-next-line radix
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  };
  var handleClickOutside = function handleClickOutside(event) {
    var external = [];
    var ids = ['menu-container', 'menu-button-desktop', 'menu-button-mobile'];
    ids.map(function (id) {
      var el = document.getElementById(id);
      return el ? external.push(el) : null;
    });
    if (external && !external.find(function (x) {
      return x && x.contains(event.target);
    })) {
      closeMenu();
      document.removeEventListener('click', handleClickOutside, true);
    }
  };
  var handleLinkClick = function handleLinkClick(text) {
    if (tagManager) {
      var tagManagerArgs = {
        dataLayer: {
          event: 'trackEvent',
          eventCategory: 'Navigation',
          eventAction: 'Header',
          eventLabel: text
        }
      };
      tagManager(tagManagerArgs);
    }
  };
  var showTranslation = function showTranslation(translation) {
    return translations[translation];
  };
  return /*#__PURE__*/React.createElement(HeaderTagStyled, null, /*#__PURE__*/React.createElement(HeaderContainer, null, /*#__PURE__*/React.createElement(MainHeader, {
    isFocus: isFocus
  }, /*#__PURE__*/React.createElement(LeftContent, null, (!isFocus || !isMobile) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LogoContainer, {
    href: baseUrl,
    onMouseDown: function onMouseDown() {
      return handleLinkClick('Agrofy');
    }
  }, /*#__PURE__*/React.createElement(AgrofyLogoFull, {
    width: "152px",
    height: "100%"
  }), /*#__PURE__*/React.createElement(AgrofyLogo, {
    width: "32px",
    height: "32px",
    fill: "white"
  }))), /*#__PURE__*/React.createElement(SearchBar, {
    clickCallback: function clickCallback() {
      return setIsFocus(!isFocus);
    },
    isFocus: isMobile && isFocus
  })), (!isFocus || !isMobile) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UserWrapper, {
    notifications: notificationsBuilt,
    loadingUser: loadingUser,
    loadingNotifications: loadingNotifications,
    buttons: headerButtons.buttons,
    tagManager: tagManager
  }), /*#__PURE__*/React.createElement(HamburgerButtonContainer, null, /*#__PURE__*/React.createElement(AgroHamburgerButton, {
    onClick: function onClick(e) {
      if (_onClick) {
        _onClick(e);
      }
      !isOpenMenu ? openMenu() : closeMenu();
    },
    isActive: isOpenMenu,
    notifications: notificationsBuilt
  })))), !isMobile && /*#__PURE__*/React.createElement(CategoriesContainer, null, /*#__PURE__*/React.createElement(CategoriesButton, {
    id: "menu-button-desktop",
    onClick: function onClick(e) {
      if (_onClick) {
        _onClick(e);
      }
      !isOpenMenu ? openMenu() : closeMenu();
    },
    "data-cy": "desktop-button"
  }, /*#__PURE__*/React.createElement(IhamburgerMenu, {
    height: "24px",
    width: "24px",
    fill: "gray800"
  }), /*#__PURE__*/React.createElement("a", null, showTranslation('categories'))), loading ? /*#__PURE__*/React.createElement(Loading, null) : resultsOther.map(function (element, index) {
    return /*#__PURE__*/React.createElement(CategoriesItem, {
      key: index
    }, /*#__PURE__*/React.createElement("a", {
      href: element.item.Url,
      onMouseDown: function onMouseDown() {
        handleLinkClick("featured_category_".concat(element.item.Suggestion));
      }
    }, element.item.Suggestion));
  })), isOpenMenu ? /*#__PURE__*/React.createElement(MenuContainer, null, /*#__PURE__*/React.createElement("div", {
    id: "menu-container",
    "data-cy": "desktop-menu"
  }, /*#__PURE__*/React.createElement(DesktopMenu, {
    items: itemsMenuDesktop,
    isOpen: isOpenMenu,
    isLoading: isLoadingMenu,
    onlineStores: onlineStore.Name,
    onlineStoresLink: onlineStore.URL,
    onlineStoresLogo: onlineStore.Icon,
    tagManager: tagManager
  }), itemsMenuMobile.length ? /*#__PURE__*/React.createElement(MobileMenu, {
    items: itemsMenuMobile,
    isOpen: isOpenMenu,
    isLoading: isLoadingMenu,
    tagManager: tagManager
  }) : /*#__PURE__*/React.createElement(MobileSpinnerContainer, null, /*#__PURE__*/React.createElement(AgroSpinner, {
    variant: "white",
    size: "48px"
  })))) : ''));
});
Header.propTypes = {
  menuData: PropTypes.object,
  user: PropTypes.object,
  notifications: PropTypes.object,
  loadingUser: PropTypes.bool,
  loadingNotifications: PropTypes.bool
};
Header.displayName = 'Header';
export { Header };